module.exports = __webpack_public_path__ + "media/images/icons/smp_financing-eb296aa9609e2120e3bab05b9bf61cb6.svg";